import { render, staticRenderFns } from "./AssignUserToFiliale.vue?vue&type=template&id=0c1e8254&scoped=true"
import script from "./AssignUserToFiliale.vue?vue&type=script&lang=js"
export * from "./AssignUserToFiliale.vue?vue&type=script&lang=js"
import style0 from "./AssignUserToFiliale.vue?vue&type=style&index=0&id=0c1e8254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e8254",
  null
  
)

export default component.exports